module.exports = "/call-frontend/img/bg.2b8ac23f.png";